import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  mainURL = '';
  baseURL = environment.baseURL;
  constructor(private http: HttpClient, private userInfoSerivce: UserInfoService) {
    this.mainURL = 'api/user/' + this.userInfoSerivce.getUserId() + '/video/';
  }

  getVideo(videoPath: string) {
    return this.http.post(this.baseURL + this.mainURL + 'getVideo',  videoPath);
  }

  getVideoPlaylist(videoName: string) {
    return this.http.get(this.baseURL + this.mainURL + 'playlist/' + videoName, { responseType: 'text' });
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }
}
